import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className={`fixed w-full z-50 transition-all duration-300 border-b border-white/5 ${
        scrolled ? 'bg-charcoal-950/95 backdrop-blur-md py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="container mx-auto px-6 md:px-12 flex justify-between items-center">
        
        {/* Logo */}
        <a href="#home" className="flex items-center cursor-pointer block">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/d334477e75b4fabb65d5be5423d2041faad258e6d76e6691f8155cb326e304c728474a3a46f4e57b3b2d456fd1aa0681/images/aW1hZ2UvanBlZw==/8828e18fef6fb00dc96be6d038a45d2a.jpg" 
            alt="Atlantic Real Estate Solutions" 
            className="h-12 md:h-14 w-auto object-contain rounded-md shadow-lg shadow-black/20"
          />
        </a>

        {/* Center Links */}
        <div className="hidden md:flex items-center gap-10">
          <a href="#home" className="text-gray-300 hover:text-gold-500 transition-colors text-sm font-medium">Home</a>
          <a href="#about" className="text-gray-300 hover:text-gold-500 transition-colors text-sm font-medium">Why Choose Us</a>
          <a href="#services" className="text-gray-300 hover:text-gold-500 transition-colors text-sm font-medium flex items-center gap-1">Services <SafeIcon name="ChevronDown" size={14}/></a>
          <a href="#process" className="text-gray-300 hover:text-gold-500 transition-colors text-sm font-medium">Process</a>
        </div>

        {/* CTA */}
        <div className="hidden md:block">
          <a href="#contact" className="btn-gold text-sm uppercase tracking-wide rounded-sm">
            Consultation
          </a>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;